import React from "react";
import { useSelector } from "react-redux";
import LoyaltyPointComponent from "./loyaltyPoint.component";

export default function LoyaltyPointContainer({ id, currentLanguage, isTemplateEditor, getTranslation }) {
  const { isVisible } = useSelector(state => isTemplateEditor
    ? state.products.template.workspaceSetting.setting.components[id]
    : state.productPage.components[id]);

  return (
    isVisible && <LoyaltyPointComponent currentLanguage={currentLanguage} getTranslation={getTranslation} />
  );
}
